import "./Accommodations.module.css";
import Header from "@/reusable_sections/Header";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
import ClinicFacilityGallery from "./sections/ClinicFacilityGallery";
export default function AccommodationsPage() {
  return <div>
      <Header />
      <CommonQuestions />
      <ClinicFacilityGallery />
      <Footer />
    </div>;
}